import { render, staticRenderFns } from "./RacePage.vue?vue&type=template&id=f0d5cc4c&"
import script from "./RacePage.vue?vue&type=script&lang=js&"
export * from "./RacePage.vue?vue&type=script&lang=js&"
import style0 from "./RacePage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports